import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { connect } from 'react-redux';
import { sendPasswordResetLink, clearSendPasswordResetLink } from 'redux/users/actions';

import { Field, reduxForm } from 'redux-form';
import { Form } from 'semantic-ui-react';

import InputTextField from 'components/redux-form-adapters/InputTextField';
// import TextField from 'components/redux-form-adapters/TextField';
import Button from 'components/elements/buttons/Button';
import CommonMessage from 'components/common/CommonMessage';

import validate from './validate';


const PasswordRecoveryForm = props => {
  const {
    handleSubmit,
    sendPasswordResetLink,
    clearSendPasswordResetLink,
    sendPasswordResetLinkSuccess,
    sendPasswordResetLinkError,
    valid,
    userEmail,
  } = props;
  const { t } = useTranslation();

  useEffect(() => {
    return () => {
      clearSendPasswordResetLink();
    };
  }, []);

  const _handleSubmit = values => {
    sendPasswordResetLink(values.email);
  };

  return (
    <div className="password-recovery-form__component">
      <h1>{t("Password Recovery")}</h1>

      {!sendPasswordResetLinkSuccess &&
        <Form
          onSubmit={handleSubmit(_handleSubmit)}
          error={!valid}
        >
          {/* Email Address */}
          <Field
            label={t("Email Address")}
            component={InputTextField}
            name="email"
            type="email"
            // placeholder="Enter your email"
            required
          />

          <Button
            submit
            disabled={!valid}
          >
            {t("send reset link")}
          </Button>

        </Form>
      }

      {sendPasswordResetLinkSuccess &&
        sendPasswordResetLinkSuccess.detail &&
        <CommonMessage success>
          {t("Open the email we just sent you to reset your password. ")}
          {<div className="bold">{userEmail ? userEmail.values.email: ""}</div>}
          {t("Didn't see the email? Check your spam folder.")}
        </CommonMessage>
      }

      {sendPasswordResetLinkError &&
        <CommonMessage
          error
          errors={sendPasswordResetLinkError}
        />
      }

    </div>
  );
};

PasswordRecoveryForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  sendPasswordResetLink: PropTypes.func.isRequired,
  clearSendPasswordResetLink: PropTypes.func.isRequired,
  sendPasswordResetLinkSuccess: PropTypes.object,
  sendPasswordResetLinkError: PropTypes.object,
};

PasswordRecoveryForm.defaultProps = {
  sendPasswordResetLinkSuccess: null,
  sendPasswordResetLinkError: null,
};

const mapStateToProps = state => (
  {
    sendPasswordResetLinkSuccess: state.usersReducer.sendPasswordResetLinkSuccess,
    sendPasswordResetLinkError: state.usersReducer.sendPasswordResetLinkError,
    userEmail: state.form.PasswordRecoveryForm,
  }
);

export default connect(
  mapStateToProps,
  {
    sendPasswordResetLink,
    clearSendPasswordResetLink,
  },
)(reduxForm({
  form: 'PasswordRecoveryForm',
  validate,
})(PasswordRecoveryForm));
